import { Screen } from '~/screens/PendingUser';

export const PendingUser = () => <Screen />;
